// extracted by mini-css-extract-plugin
module.exports = {"stickyTop":"use-sticky-top_stickyTop__c2LiR","active":"use-sticky-top_active__d9L78"};